/** @module csi/_base/config */
define([
	"dojo/has"
], function(has) {

	/**
	 * Overrides dojo/_base/config module - still require as "dojo/_base/config"
	 */

	function adviseHas(featureSet, prefix, booting) {
		for (var p in featureSet) {
			if (p != "has") {
				has.add(prefix + p, featureSet[p], 0, booting);
			}
		}
	}

	var result = require.rawConfig;

	// mixin properties from global dojoConfig
	if (dojoConfig) {
		adviseHas(dojoConfig.has, "", 1);
		result.isDebug = !!dojoConfig.isDebug;
	}

	adviseHas(result, "config", 1);
	adviseHas(result.has, "", 1);

	// disable "touch" do disable dojo module touch.js functionality which we are not using but which causing bugs
	has.add("touch", false, true, true);

	// set additional properties which always apply
	result.transparentColor = [255, 255, 255, 0];

	// resolve locale
	if (!result.locale) {
		var loc;
		var matches;

		if (matches = String(window.location).match(/\?Locale=(.*?)(#|$)/)) {
			loc = decodeURIComponent(matches[1]);
		} else if (localStorage["Locale"]) {
			// set locale based on local storage
			try {
				loc = JSON.parse(localStorage["Locale"]);
			} catch (ex) {
				// don't let this stop us if local storage is not proper JSON
			}
		} else if (matches = document.cookie.match(/(?:^|; )Locale=([^;]*)/)) {
			// set locale based on cookie
			loc = decodeURIComponent(matches[1]);
		}

		if (loc) {
			result.locale = loc.replace(/_/g, "-").toLowerCase();
		} else if (typeof navigator != "undefined") {
			// Default locale for browsers (ensure it's read from user-settings not download locale).
			var language = (navigator.languages && navigator.languages.length) ? navigator.languages[0] : (navigator.language || navigator.userLanguage);
			if (language) {
				result.locale = language.toLowerCase();
			}
		}
	}

	return result;

});